import React, { useContext } from 'react'
import { GlobalStyle } from './globalStyle'
import '@fontsource/roboto-slab'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Router from './router'
import { UserProvider } from './contexts/UserContext'
import { TenantProvider } from './contexts/TenantContext'
import TenantMissingBanner from './components/TenantMissingBanner'
import { StockProvider } from './contexts/StockContext'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { SectionProvider } from './contexts/SectionContext'
import { ImportFromExcelProvider } from './contexts/ImportFromExcelContext'
import { TableFiltersProvider } from './contexts/TableFiltersContext'
import { ModalProvider } from './contexts/ModalContext'
import { OrdersProvider } from './contexts/OrdersContext'
import { ParametersProvider } from './contexts/ParametersContext'
import { CertificatesProvider } from './contexts/CertificatesContext'
import Compose from './contexts/Compose'
import { ProfileProvider } from './contexts/AccessesContext'
import { SearchAccessesProvider } from './contexts/SearchAccessesContext'
import { FeedbackContext, FeedbackProvider } from './contexts/FeedbackContext'
import { ServicesProvider } from './contexts/ServicesContext'
import { OccurrenceProvider } from './contexts/OccurrenceContext'
import { MachineProvider } from './contexts/MachineContext'
import { QrCodeProvider } from './contexts/QRCodeContext'
import { ReportProvider } from './contexts/ReportContext'
import './config/axios'
import { FreightProvider } from './contexts/FreightContext'
import { VehicleProvider } from './contexts/VehicleContext'
import { ClientProvider } from './contexts/ClientContext'
import { RouterProvider } from './contexts/RouterContext'
import { RouterInfoProvider } from './contexts/RouterInfoContext'
import GlobalLoadingOverlay from './components/GlobalLoadingOverlay'
import UserContext from './contexts/UserContext'
import { UserPreferencesProvider } from './contexts/UserPreferencesContext'

const AppContent: React.FC = () => {
  const { isLoadingAuth } = useContext(UserContext)

  return (
    <>
      {isLoadingAuth && <GlobalLoadingOverlay />}
      <TenantMissingBanner />
      <Compose components={[
        UserPreferencesProvider,
        SectionProvider,
        ModalProvider,
        FeedbackProvider,
        TableFiltersProvider,
        StockProvider,
        OrdersProvider,
        ImportFromExcelProvider,
        SearchAccessesProvider,
        ProfileProvider,
        CertificatesProvider,
        ParametersProvider,
        ServicesProvider,
        OccurrenceProvider,
        MachineProvider,
        ReportProvider,
        QrCodeProvider,
        FreightProvider,
        VehicleProvider,
        ClientProvider,
        RouterProvider,
        RouterInfoProvider
      ]}>
        <GlobalStyle />
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />
        <Router />
      </Compose>
    </>
  )
}

const App: React.FC = () => {
  return (
    <GoogleOAuthProvider clientId='963662575465-hbce4u67fa4t8q4acma8biosc8if50te.apps.googleusercontent.com'>
      <UserProvider>
        <TenantProvider>
          <AppContent />
        </TenantProvider>
      </UserProvider>
    </GoogleOAuthProvider>
  )
}

export default App
